/**
 * Mock data for the (fake) "Production - Béton" dashboard.
 *
 * Ported verbatim from the standalone HTML prototype (tbm_dashboard.html).
 * This page is a demo: it is fully self-contained and does NOT hit the API or
 * the Vuex store. All values below are fictitious.
 */

// Single plant for the demo.
export const CONCRETE_USINE = {
  id: 'USINE-01',
  name: 'Usine Granby',
}

// Constituents plotted on the "Écart de dosage" line chart.
// `deviationKey` points to the per-load deviation field in each `bav` entry.
// `label` is the i18n sub-key under views.dashboard.concrete.constituents.
export const CONCRETE_CONSTITUENTS = [
  { deviationKey: 'liantD', label: 'liant' },
  { deviationKey: 'eauD', label: 'eau' },
  { deviationKey: 'sableD', label: 'sable' },
  { deviationKey: 'p1014D', label: 'pierre1020' },
  { deviationKey: 'p520D', label: 'pierre514' },
  { deviationKey: 'airD', label: 'air' },
]

// Dosage parameters shown in the left "Dosage (kg/m³)" table.
// `warn` / `crit` are the |deviation| thresholds (%) for the SURVEILLER / ALERTE
// badges and the status dot.
export const CONCRETE_DOSAGE_PARAMS = [
  {
    label: 'liant',
    thKey: 'liant',
    actKey: 'liant',
    devKey: 'liantD',
    warn: 1,
    crit: 2,
  },
  {
    label: 'eau',
    thKey: 'eau',
    actKey: 'eau',
    devKey: 'eauD',
    warn: 1.5,
    crit: 3,
  },
  {
    label: 'sable',
    thKey: 'sable',
    actKey: 'sable',
    devKey: 'sableD',
    warn: 1,
    crit: 2,
  },
  {
    label: 'pierre1020',
    thKey: 'p1014',
    actKey: 'p1014',
    devKey: 'p1014D',
    warn: 1,
    crit: 2,
  },
  {
    label: 'pierre514',
    thKey: 'p520',
    actKey: 'p520',
    devKey: 'p520D',
    warn: 1,
    crit: 2,
  },
  {
    label: 'air',
    thKey: 'air',
    actKey: 'air',
    devKey: 'airD',
    warn: 2,
    crit: 5,
  },
]

export const CONCRETE_DATA = {
  '2520AAE': {
    label: '2520AAE',
    proj: 'Projet Général DAWAY',
    mpa: 25,
    th: { liant: 343, eau: 171, sable: 728, p1014: 731, p520: 365, air: 22 },
    cible: { liant: 343, eau: 171, sable: 728, p1014: 731, p520: 365, air: 22 },
    res: {
      wcm: { val: 0.513, cible: 0.5 },
      air: { val: 4.5, cible: 5.5 },
      slump: { val: 85, cible: 80 },
      temp: { val: 30.5, cible: 20 },
      mv: { val: 2368, cible: 2338 },
      fc28: { val: 26.5, cible: 25 },
    },
    bav: [
      {
        n: 10,
        liant: 342.7,
        eau: 175.7,
        sable: 732.4,
        p1014: 728.8,
        p520: 363.2,
        air: 22.42,
        liantD: -0.087,
        eauD: 2.749,
        sableD: 0.604,
        p1014D: 0.301,
        p520D: 0.493,
        airD: 1.818,
        vol: 9.0,
      },
      {
        n: 9,
        liant: 341.9,
        eau: 175.2,
        sable: 731.9,
        p1014: 735.3,
        p520: 371.3,
        air: 23.75,
        liantD: -0.321,
        eauD: 2.456,
        sableD: 0.536,
        p1014D: 0.588,
        p520D: 1.726,
        airD: 7.955,
        vol: 8.25,
      },
      {
        n: 8,
        liant: 344.3,
        eau: 170.8,
        sable: 736.1,
        p1014: 728.2,
        p520: 360.5,
        air: 20.99,
        liantD: 0.379,
        eauD: -0.117,
        sableD: 1.113,
        p1014D: -0.383,
        p520D: -1.233,
        airD: -4.591,
        vol: 8.75,
      },
      {
        n: 7,
        liant: 341.4,
        eau: 172.9,
        sable: 713.5,
        p1014: 732.3,
        p520: 364.7,
        air: 21.58,
        liantD: -0.466,
        eauD: 1.111,
        sableD: -1.992,
        p1014D: 0.178,
        p520D: -0.082,
        airD: -1.909,
        vol: 9.0,
      },
      {
        n: 6,
        liant: 345.3,
        eau: 174.7,
        sable: 724.7,
        p1014: 729.0,
        p520: 361.2,
        air: 20.81,
        liantD: 0.671,
        eauD: 2.164,
        sableD: -0.453,
        p1014D: -0.274,
        p520D: -1.041,
        airD: -5.409,
        vol: 7.25,
      },
      {
        n: 5,
        liant: 344.0,
        eau: 176.0,
        sable: 745.7,
        p1014: 728.3,
        p520: 370.6,
        air: 23.15,
        liantD: 0.292,
        eauD: 2.924,
        sableD: 2.431,
        p1014D: -0.369,
        p520D: 1.534,
        airD: 5.227,
        vol: 8.0,
      },
      {
        n: 4,
        liant: 342.2,
        eau: 176.9,
        sable: 717.6,
        p1014: 736.8,
        p520: 367.1,
        air: 20.56,
        liantD: -0.233,
        eauD: 3.45,
        sableD: -1.429,
        p1014D: 0.793,
        p520D: 0.575,
        airD: -6.545,
        vol: 9.25,
      },
      {
        n: 3,
        liant: 345.7,
        eau: 173.3,
        sable: 720.3,
        p1014: 730.0,
        p520: 360.7,
        air: 21.01,
        liantD: 0.787,
        eauD: 1.345,
        sableD: -1.058,
        p1014D: -0.137,
        p520D: -1.178,
        airD: -4.5,
        vol: 8.75,
      },
      {
        n: 2,
        liant: 343.9,
        eau: 174.7,
        sable: 723.6,
        p1014: 730.0,
        p520: 368.2,
        air: 20.67,
        liantD: 0.262,
        eauD: 2.164,
        sableD: -0.604,
        p1014D: -0.137,
        p520D: 0.877,
        airD: -6.045,
        vol: 7.5,
      },
      {
        n: 1,
        liant: 342.7,
        eau: 175.7,
        sable: 732.4,
        p1014: 728.8,
        p520: 363.2,
        air: 22.42,
        liantD: -0.087,
        eauD: 2.749,
        sableD: 0.604,
        p1014D: -0.301,
        p520D: -0.493,
        airD: 1.909,
        vol: 9.5,
      },
    ],
    chantier: [
      {
        n: 10,
        transit: 32,
        slump: 80,
        air: 5.7,
        density: 2309,
        temp: 26.5,
        water: 0,
      },
      {
        n: 9,
        transit: 66,
        slump: 85,
        air: 4.7,
        density: 2359,
        temp: 28.2,
        water: 0,
      },
      {
        n: 8,
        transit: 67,
        slump: 70,
        air: 4.8,
        density: 2366,
        temp: 28.1,
        water: 0,
      },
      {
        n: 7,
        transit: 77,
        slump: 65,
        air: 4.4,
        density: 2361,
        temp: 30.2,
        water: 0,
      },
      {
        n: 6,
        transit: 97,
        slump: 75,
        air: 3.7,
        density: 2387,
        temp: 28.9,
        water: 0,
      },
      {
        n: 5,
        transit: 62,
        slump: 85,
        air: 5.5,
        density: 2326,
        temp: 27.5,
        water: 0,
      },
      {
        n: 4,
        transit: 96,
        slump: 75,
        air: 3.8,
        density: 2391,
        temp: 27.8,
        water: 0,
      },
      {
        n: 3,
        transit: 59,
        slump: 95,
        air: 5.0,
        density: 2327,
        temp: 28.8,
        water: 0,
      },
      {
        n: 2,
        transit: 42,
        slump: 85,
        air: 5.2,
        density: 2336,
        temp: 25.7,
        water: 0,
      },
      {
        n: 1,
        transit: 83,
        slump: 85,
        air: 4.5,
        density: 2368,
        temp: 30.5,
        water: 0,
      },
    ],
    count: { total: 46, conformes: 18, critiques: 8 },
  },
  '35887TV': {
    label: '35887TV',
    proj: 'MTMD 2025',
    mpa: 35,
    th: { liant: 340, eau: 153, sable: 682, p1014: 544, p520: 627, air: 25 },
    cible: { liant: 340, eau: 153, sable: 682, p1014: 544, p520: 627, air: 25 },
    res: {
      wcm: { val: 0.454, cible: 0.45 },
      air: { val: 6.1, cible: 6.5 },
      slump: { val: 80, cible: 80 },
      temp: { val: 19.8, cible: 20 },
      mv: { val: 2366, cible: 2346 },
      fc28: { val: 45.5, cible: 35 },
    },
    bav: [
      {
        n: 10,
        liant: 340.3,
        eau: 156.6,
        sable: 682.7,
        p1014: 542.3,
        p520: 623.8,
        air: 24.38,
        liantD: 0.088,
        eauD: 2.353,
        sableD: 0.103,
        p1014D: -0.313,
        p520D: -0.51,
        airD: -2.48,
        vol: 7.0,
      },
      {
        n: 9,
        liant: 340.4,
        eau: 156.7,
        sable: 693.2,
        p1014: 547.4,
        p520: 626.0,
        air: 24.03,
        liantD: 0.118,
        eauD: 2.81,
        sableD: 1.906,
        p1014D: 0.625,
        p520D: -0.159,
        airD: -3.88,
        vol: 9.5,
      },
      {
        n: 8,
        liant: 341.5,
        eau: 156.1,
        sable: 687.7,
        p1014: 548.2,
        p520: 622.8,
        air: 24.81,
        liantD: 0.441,
        eauD: 2.026,
        sableD: 0.836,
        p1014D: 0.772,
        p520D: -0.67,
        airD: -0.76,
        vol: 8.25,
      },
      {
        n: 7,
        liant: 340.4,
        eau: 156.7,
        sable: 693.2,
        p1014: 550.6,
        p520: 633.7,
        air: 24.81,
        liantD: 0.118,
        eauD: 2.418,
        sableD: 1.642,
        p1014D: 1.213,
        p520D: 1.069,
        airD: -0.76,
        vol: 8.0,
      },
      {
        n: 6,
        liant: 340.3,
        eau: 155.3,
        sable: 682.4,
        p1014: 543.3,
        p520: 630.6,
        air: 26.29,
        liantD: 0.088,
        eauD: 1.503,
        sableD: 0.059,
        p1014D: -0.129,
        p520D: 0.574,
        airD: 5.16,
        vol: 7.25,
      },
      {
        n: 5,
        liant: 339.7,
        eau: 152.7,
        sable: 682.4,
        p1014: 541.2,
        p520: 626.4,
        air: 26.72,
        liantD: -0.088,
        eauD: -0.196,
        sableD: 0.059,
        p1014D: -0.515,
        p520D: -0.096,
        airD: 6.88,
        vol: 8.75,
      },
      {
        n: 4,
        liant: 339.7,
        eau: 153.4,
        sable: 672.4,
        p1014: 550.8,
        p520: 618.1,
        air: 25.15,
        liantD: -0.088,
        eauD: 0.392,
        sableD: -1.408,
        p1014D: 1.25,
        p520D: -0.882,
        airD: 0.6,
        vol: 9.75,
      },
      {
        n: 3,
        liant: 337.8,
        eau: 153.6,
        sable: 689.1,
        p1014: 543.3,
        p520: 630.0,
        air: 24.82,
        liantD: -0.647,
        eauD: 0.458,
        sableD: 1.041,
        p1014D: -0.129,
        p520D: 0.478,
        airD: -0.72,
        vol: 6.75,
      },
      {
        n: 2,
        liant: 338.6,
        eau: 152.5,
        sable: 677.2,
        p1014: 539.4,
        p520: 624.9,
        air: 24.32,
        liantD: -0.412,
        eauD: -0.327,
        sableD: -0.703,
        p1014D: -0.846,
        p520D: -0.335,
        airD: -2.72,
        vol: 9.5,
      },
      {
        n: 1,
        liant: 338.8,
        eau: 153.7,
        sable: 689.1,
        p1014: 543.3,
        p520: 630.0,
        air: 24.82,
        liantD: -0.353,
        eauD: 0.458,
        sableD: 1.041,
        p1014D: -0.129,
        p520D: 0.478,
        airD: -0.72,
        vol: 7.0,
      },
    ],
    chantier: [
      {
        n: 10,
        transit: 60,
        slump: 95,
        air: 6.5,
        density: 2334,
        temp: 23.2,
        water: 0,
      },
      {
        n: 9,
        transit: 72,
        slump: 85,
        air: 5.5,
        density: 2370,
        temp: 28.0,
        water: 0,
      },
      {
        n: 8,
        transit: 83,
        slump: 70,
        air: 6.5,
        density: 2325,
        temp: 27.1,
        water: 0,
      },
      {
        n: 7,
        transit: 61,
        slump: 90,
        air: 6.4,
        density: 2362,
        temp: 27.4,
        water: 0,
      },
      {
        n: 6,
        transit: 45,
        slump: 80,
        air: 5.9,
        density: 2383,
        temp: 28.9,
        water: 0,
      },
      {
        n: 5,
        transit: 70,
        slump: 85,
        air: 5.4,
        density: 2364,
        temp: 27.5,
        water: 0,
      },
      {
        n: 4,
        transit: 63,
        slump: 65,
        air: 6.9,
        density: 2359,
        temp: 24.7,
        water: 0,
      },
      {
        n: 3,
        transit: 80,
        slump: 65,
        air: 5.7,
        density: 2325,
        temp: 27.6,
        water: 0,
      },
      {
        n: 2,
        transit: 63,
        slump: 90,
        air: 6.5,
        density: 2334,
        temp: 23.1,
        water: 0,
      },
      {
        n: 1,
        transit: 49,
        slump: 80,
        air: 6.1,
        density: 2366,
        temp: 19.8,
        water: 0,
      },
    ],
    count: { total: 23, conformes: 13, critiques: 3 },
  },
}
